module.exports = __webpack_public_path__ + "img/06_l.f69aad89.webp";